export default __webpack_public_path__ + "components/weather-icon/static/nightmodrain-3af105651f3a3ccc06a0b898b160beb8.png";